<template>
  <div class="main-contenter">
    <layout v-if="publicAppMounted"></layout>
    <div id="publicComponents"></div>
  </div>
</template>

<script>
import { mixin } from "@/mixins/app.js"
import { getLanguage } from '@/utils/auth'

export default {
  name: 'App',
  components: {
    layout: () => import("@/layout/index.vue")
  },
  mounted() {
    
    // let value = getLanguage()
    // if(value == 'zh-CN'){
    //     location.href = "/#"+this.$route.path
    // }else {
    //     location.href = "/ft/#"+this.$route.path
    // }
  },
  mixins: [mixin]
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  height: 100%;
}

.el-select__tags {
  display: flex;

  .el-tag--info,
  .el-select__tags-text {
    max-width: calc(100% - 70px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
<style lang="scss" scoped>
.main-contenter {
  width: 100%;
  height: 100%;
  /*line-height: 32px;
  font-size:16px;*/
}
</style>
